export var ROLE;
(function (ROLE) {
    ROLE[ROLE["ADMINISTRATOR"] = 1] = "ADMINISTRATOR";
    ROLE[ROLE["MANAGER"] = 2] = "MANAGER";
    ROLE[ROLE["MEMBER"] = 4] = "MEMBER";
    ROLE[ROLE["AWAITER"] = 8] = "AWAITER";
    ROLE[ROLE["BANNED"] = 9] = "BANNED";
    ROLE[ROLE["NONMEMBER"] = 10] = "NONMEMBER";
})(ROLE || (ROLE = {}));
